import {Inject, Injectable, InjectionToken, Optional} from '@angular/core';
import {HttpRequest} from '@angular/common/http';

export const /** @type {?} */ TRANSFER_RESPONSE_BASE_URLS = new InjectionToken<string []>('request cache base url');
export class RequestKeyExtractorService {
/**
 * @param {?} baseUrls
 */
constructor(
private baseUrls: string[]) {
    this.baseUrls = ([].concat(this.baseUrls || [])).reduce((result, item) => result.concat(item), []);
  }
/**
 * @param {?} httpRequest
 * @return {?}
 */
getKey(httpRequest: HttpRequest<any>): string {
    let /** @type {?} */ url = httpRequest.url;
    this.baseUrls.some((baseUrl, index) => {
      if (url.indexOf(baseUrl) === 0) {
        url = `__BASE_URL_${index}__` + url.slice(baseUrl.length);
        return true;
      }
    });
    return url;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Array, decorators: [{ type: Optional }, { type: Inject, args: [TRANSFER_RESPONSE_BASE_URLS, ] }, ]},
];
}

function RequestKeyExtractorService_tsickle_Closure_declarations() {
/** @type {?} */
RequestKeyExtractorService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RequestKeyExtractorService.ctorParameters;
/** @type {?} */
RequestKeyExtractorService.prototype.baseUrls;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
